module.exports = __webpack_public_path__ + "img/vertical_1_1_9006.5bc74b72.png";